<template>
  <div class="leaflet-title">
    <!-- 标题 -->
    <div class="leaflet-title-header">
      <div class="leaflet-title-title">{{ title }}</div>
      <div class="leaflet-title-solt">
        <slot/>
      </div>
    </div>
    <div class="leaflet-title-bottom">
      <div class="leaflet-title-block"></div>
      <div class="leaflet-title-line"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LeafletTitle',
  props: {
    title: {type: String, default: '这是标题'},
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {},
}
</script>

<style lang="less" scoped>
.leaflet-title {
  box-sizing: border-box;

  .leaflet-title-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .leaflet-title-title {
      color: rgba(61, 63, 68, 1);
      font-size: 22px;
      font-family: 'Harmony Medium';
      line-height: 26px;
    }

    .leaflet-title-solt {
    }
  }

  .leaflet-title-bottom {
    display: flex;
    align-items: center;
    margin-top: 16px;

    .leaflet-title-block {
      width: 24px;
      height: 4px;
      background: rgba(85, 116, 223, 1);
    }

    .leaflet-title-line {
      width: 100%;
      height: 1px;
      background-color: rgba(204, 211, 235, 1);
    }
  }
}
</style>
